const DEFAULT_SITE_TITLE = 'Sttok';
const DEFAULT_FAVICON = 'favicon.ico';

export const initPageUpdate = () => {
  const siteTitle = process.env.REACT_APP_UI_SITE_TITLE || DEFAULT_SITE_TITLE;
  document.title = siteTitle;

  const favicon = process.env.REACT_APP_UI_FAVICON || DEFAULT_FAVICON;
  const faviconElement = document.querySelector("link[rel='icon']");
  if (faviconElement) {
    faviconElement.href = `${process.env.PUBLIC_URL}/${favicon}`;
  }
};
